/* eslint-disable react-hooks/rules-of-hooks */
import './AddEmployeeForm.css'
import CustomInput from "../CustomInput/CustomInput";
import CustomBtn from "../CustomBtn/CustomBtn";
import { useEffect, useState } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import "react-toastify/dist/ReactToastify.css";
import Select from 'react-select';

// import axios from 'axios';
import { useSelector } from 'react-redux';
import { toast, ToastContainer } from 'react-toastify';
import { useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';

function index() {
  const {id}=useParams();
  console.log(id);
  
  const userinfo = useSelector((state) => state);
  const { currentLocal } = useSelector((state) => state.currentLocal);
  const navigate = useNavigate();

  // eslint-disable-next-line react-hooks/rules-of-hooks
  const [type_id, setType_id] = useState("");

  const [name, setName] = useState('')
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const [email, setEmail] = useState('')
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const [password, setPssword] = useState('')
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const [phone, setPhone] = useState('')

  // eslint-disable-next-line react-hooks/rules-of-hooks
  const [loading, setLoading] = useState(false)
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const [jobTitle, setJobTitle] = useState("")
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const [roleData, setRoleData] = useState([])

  // eslint-disable-next-line react-hooks/rules-of-hooks
  const [roles, setRole] = useState([])
  useEffect(() => {
    const getAllApis = async () => {

      await axios
        .get(`https://nanosoft.space/taarteb/public/api/admin/employee-roles`, {
          headers: {
            Authorization: `Bearer ${userinfo.auth.userArray.access_token}`
          }
        })
        .then(async (res) => {

          const nameMap = {
            "Financial Director": currentLocal.home.Financialofficer,
            "Sales Employee": currentLocal.home.salesemployee,
            "Purchasing Employee": currentLocal.home.Purchasingemployee,
            "Salaries Employee": currentLocal.home.Salariesemployee,
            "Maintenance Employee": currentLocal.home.Maintenanceemployee,
            "Other": currentLocal.home.Other,

          };
          console.log(nameMap);

          const translatedData = res.data.data.map((role) => ({
            ...role,
            name: nameMap[role.name] || role.name, // fallback to English if no translation
          }));
          const roleOptions = translatedData.map(item => ({
            value: item.id,
            label: item.name
          }));

          setRole(roleOptions)


        })
        .catch((error) => {





        });
            await axios
                    .get(`https://nanosoft.space/taarteb/public/api/admin/employees`, {
                        headers: {
                            Authorization: `Bearer ${userinfo.auth.userArray.access_token}`
                        }
                    })
                    .then(async (res) => {
                      console.log(res.data.data.data);
                      const customData=res.data.data.data?.find((item)=>item?.id==id)
                      console.log(customData);
                      setName(customData?.name)
                      setEmail(customData?.email)
                      setPhone(customData?.phone)
                      setJobTitle(customData?.jobTitle)
setRoleData(customData?.roles)

              const nameMap = {
        "Financial Director": currentLocal.home.Financialofficer,
        "Sales Employee":currentLocal.home.salesemployee,
        "Purchasing Employee": currentLocal.home.Purchasingemployee,
        "Salaries Employee": currentLocal.home.Salariesemployee,
        "Maintenance Employee":currentLocal.home.Maintenanceemployee,
                    "Other": currentLocal.home.Other,
    
      };
                          const translatedEmployees = res.data.data.data.map((emp) => ({
        ...emp,
        role: nameMap[emp.role] || emp.role, // translate main role
        roles: emp.roles.map((r) => ({
          ...r,
          name: nameMap[r.name] || r.name, // translate nested role
        })),
      }));
      
    // setItems(translatedEmployees)
    
                    })
                    .catch((error) => {
    
    
                    });
    }
    getAllApis()

  }, [])
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);


    try {
      const response = await axios.post(id?`https://nanosoft.space/taarteb/public/api/admin/employees/${id}`:'https://nanosoft.space/taarteb/public/api/admin/employees', {
        name,
        email,
        // role_id: type_id?.value,
        password:password&&password,
        phone: phone,
        jobTitle:jobTitle&&jobTitle

      }, {
        headers: {
          Authorization: `Bearer ${userinfo.auth.userArray.access_token}`
        }
      });


      toast.success(response.data.message, { position: "bottom-right", autoClose: 3000 });
      setLoading(false);

      navigate('/dashboard/employee')

    } catch (error) {
      toast.error(Object.values(error.response.data.errors)[0][0], { position: "bottom-right", autoClose: 3000 });
      setLoading(false);


    } finally {
      setLoading(false);
    }




  };





  return (
    <div className='add_student_form_container'>
      <ToastContainer />

      <form className='form_container'>
        <Container fluid>
          <Row>
            {/* {id?roleData.map((itemData)=>{
              console.log(type_id);
              
              return(
                        <Col md={6}>
              <div>
                <label>{currentLocal.home.permissions}</label>
                <br />
                <div className='mb-3'>
                  <Select
                    value={type_id}
                    onChange={(selectedOption) => setType_id(selectedOption)}
                    options={roles}
                    placeholder={currentLocal.home.selectpermissions} // Change this text

                  />
                </div>
              </div>
            </Col>
              )
            })
            
          :
                <Col md={6}>
              <div>
                <label>{currentLocal.home.permissions}</label>
                <br />
                <div className='mb-3'>
                  <Select
                    value={type_id}
                    onChange={(selectedOption) => setType_id(selectedOption)}
                    options={roles}
                    placeholder={currentLocal.home.selectpermissions} // Change this text

                  />
                </div>
              </div>
            </Col>
          } */}
      
            <Col md={6}>
              <div>
                <label>{currentLocal.home.namePlaceholder}</label>
                <CustomInput
                  placeholder={currentLocal.home.namePlaceholder}
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                />
              </div>
            </Col>
            {/* {type_id?.value==26&&
            <Col md={6}>
              <div>
                <label>{currentLocal.home.jobTitle}</label>
                <CustomInput
                  placeholder={currentLocal.home.jobTitle}
                  value={jobTitle}
                  onChange={(e) => setJobTitle(e.target.value)}
                />
              </div>
            </Col>
} */}
            <Col md={6}>
              <div>
                <label>{currentLocal.home.emailPlaceholder}</label>
                <CustomInput
                  placeholder={currentLocal.home.emailPlaceholder}
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </div>
            </Col>
       {/* {!id&&type_id?.value!=26&&

            <Col md={6}>
              <div>
                <label>{currentLocal.home.passwordPlaceholder}</label>
                <CustomInput
                  placeholder={currentLocal.home.passwordPlaceholder}
                  value={password}
                  onChange={(e) => setPssword(e.target.value)}
                />
              </div>
            </Col>
} */}
            <Col md={6}>
              <div>
                <label>{currentLocal.home.phonePlaceholder}</label>
                <CustomInput
                  placeholder={currentLocal.home.phonePlaceholder}
                  value={phone}
                  onChange={(e) => setPhone(e.target.value)}
                />

              </div>
            </Col>
            <Col md={12}>
              <div className='d-flex justify-content-center mt-4 '>
                <div className='w-50 d-flex justify-content-center'>
                  <CustomBtn text={loading ? currentLocal.home.Loading : id?currentLocal.home.editEmploye:currentLocal.home.addEmploye} disabled={loading} clickingFunction={handleSubmit} />

                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </form>
    </div>
  )
}


export default index
